import { AxiosResponse } from 'axios'
import { Action } from 'redux'
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  SelectEffect,
  takeLatest,
} from 'redux-saga/effects'
import createContext from '../../actions/createContext'
import duplicateWorkflow from '../../actions/duplicateWorkflow'
import { fetchWorkflow } from '../../actions/fetchWorkflowByContext'
import { loadJsonApiEntities } from '../../actions/loadJsonApiEntities'
import {
  WorkflowCreateResponsePayload,
  WorkflowResponsePayload,
} from '../../actions/workflow/types'
import { workflowActions } from '../../actions/workflowActions'

type Yield = CallEffect | SelectEffect | PutEffect
type Return = void
type Next =
  | AxiosResponse<WorkflowCreateResponsePayload>
  | AxiosResponse<WorkflowResponsePayload>
  | undefined

type Payload = {
  entity: 'moment' | 'story'
  destinationId: string
  sourceId: string
}

export interface ActionWithPayload extends Action {
  payload: Payload
}

export function* duplicateWorkflowForContext(
  action: ActionWithPayload
): Generator<Yield, Return, Next> {
  try {
    let workflow: Next

    if (action.payload.entity === 'moment') {
      const workflowParams = {
        id: action.payload.sourceId,
        entity: action.payload.entity,
        expose: false,
      }
      workflow = yield call(fetchWorkflow, workflowParams)
    }

    let duplicatedWorkflow: Next

    if (workflow !== undefined) {
      yield put(loadJsonApiEntities(workflow.data))

      const sourceWorkflowId =
        Array.isArray(workflow.data.data) &&
        Boolean(workflow.data.data.length) &&
        workflow.data.data[0].id

      if (sourceWorkflowId !== undefined && sourceWorkflowId) {
        duplicatedWorkflow = yield call(duplicateWorkflow, sourceWorkflowId)
      }
    }

    let duplicatedWorkflowContext

    if (
      duplicatedWorkflow !== undefined &&
      !Array.isArray(duplicatedWorkflow.data.data)
    ) {
      yield put(loadJsonApiEntities(duplicatedWorkflow.data))

      const duplicatedWorkflowContextParams = {
        entity: action.payload.entity,
        entityId: action.payload.destinationId,
        workflowId: duplicatedWorkflow.data.data.id,
      }

      duplicatedWorkflowContext = yield call(
        createContext,
        duplicatedWorkflowContextParams
      )
    }

    if (duplicatedWorkflowContext !== undefined) {
      yield put(loadJsonApiEntities(duplicatedWorkflowContext.data))
    }
  } catch (error) {
    console.error(error)
  }
}

export function* duplicateWorkflowForContextSaga(): Generator<
  ForkEffect,
  void,
  void
> {
  yield takeLatest(
    workflowActions.DUPLICATE_WORKFLOW_FOR_CONTEXT,
    duplicateWorkflowForContext
  )
}

export default [duplicateWorkflowForContextSaga]
